const InputType = {
    Email: 'email',
    Password: 'password',
    Number: 'number',
    Search: 'search',
    Text: 'text'
}

export default InputType